<template>
  <transition appear name="slide-fade">
    <div v-if="show" class="flex gap-2 fixed debug-bar">
      <b-button @click="intentShow = false" class="close-debug rounded-full" variant="outline-danger" size="sm">
        <b-icon-x-circle-fill class="pointer-events-none"/>
      </b-button>
      <div style="max-width: 30rem;" class="flex items-center gap-2 overflow-y-hidden overflow-x-auto">
        <slot name="default">
        </slot>
      </div>
      <div class="w-24"></div>
      <div
        class="absolute text-xs text-danger font-bold pointer-events-none"
        style="bottom:0;right:0.1rem;"
      >
        DEBUG ATIVO
      </div>
    </div>
  </transition>
</template>

<script>

import {
  BButton,
  BIconXCircleFill
} from 'bootstrap-vue'

export default {
  data: () => ({
    intentShow: true,
  }),
  components: {
    BButton,
    BIconXCircleFill,
  },
  computed: {
    show() {
      return (process.env.NODE_ENV !== 'production') && this.intentShow
    }
  }
}
</script>

<style lang="scss">
button.close-debug {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}
.debug-bar {
  user-select: none;
  padding: 0.125rem;
  min-height: 2.5rem;
  max-height: 6rem;
  border-top-left-radius: 2rem;
  border-bottom-left-radius: 2rem;
  top: 2px;
  right: 0;
  background-color: rgb(0, 0, 0);
  border-width: 1px;
  border-color: red;
  color: white;
  z-index: 35000;
}

</style>